import { Stack, Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { useParams } from "react-router-dom";
import { useGetMedicationQuery } from "src/api/services/medicationsApi";
import { MatchParam } from "src/constants/matches";
import MedicationStrength from "./components/MedicationStrength";

const ProductMedicationDetails = () => {
  const { medicationId } = useParams<MatchParam<"MEDICATION_ID">>();

  const { data } = useGetMedicationQuery(
    medicationId ? Number(medicationId) : skipToken,
  );

  if (data == null) {
    return (
      <Typography>
        Looks like this medication is missing some vital information
      </Typography>
    );
  }

  return (
    <Stack width={"100%"} gap={2}>
      <Typography
        variant="h5"
        sx={{ textDecoration: "underline" }}
        textAlign={"center"}
        fontSize={"2rem"}
      >
        {data.name} - {data.dosage}
      </Typography>
      <MedicationStrength medication={data} />
    </Stack>
  );
};

export default ProductMedicationDetails;
